const dataIrrelevantProps = [
    "allowMultiSelection",
    "hoverButton",
    "isLayerShown",
    "topLeftButton",
    "user",
] as const;

// Only a subset of these should affect data loading!
const relevantProps = [
    "allowMultiSelection",
    "data",
    "hoverButton",
    "isLayerShown",
    "selectedFluffyItem",
    "selectedType",
    "subtypes",
    "topLeftButton",
    "user",
    "staticObjects",
    "reservationIds",
    "occuringObjects",
    "relatedObject",
] as const;

const getChangedProps = (nextProps, currentProps, propList: string[]) => {
    const changedProps: string[] = [];
    propList.forEach((prop) => {
        if (!_.isEqual(nextProps[prop], currentProps[prop])) {
            changedProps.push(prop);
        }
    });
    return changedProps;
};

const errorCorrectLoadedSettings = (loadedSettings) => {
    let result = loadedSettings.map((loadedSetting) => {
        let selectedCategories = { ...loadedSetting.settings.selectedCategories };
        Object.keys(selectedCategories).forEach((key) => {
            let selectedValues = selectedCategories[key];
            selectedCategories[key] = selectedValues.map((value) =>
                Array.isArray(value) ? value.flat() : value
            );
        });
        return { ...loadedSetting, settings: { ...loadedSetting.settings, selectedCategories } };
    });
    return result;
};

const RelationFilter = {
    INACTIVE: { id: 0 },
    ACTIVE: { id: 1 },
} as const;

const getUpdatedObjectStore = (
    newObjects,
    firstIndex: number,
    totalNumber: number,
    currentObjects
) => {
    const total = firstIndex === 0 ? totalNumber : currentObjects.length;
    let objectStore: object[] = currentObjects ? [].concat(currentObjects) : [];
    if (newObjects.length === 0 && firstIndex === 0 && totalNumber > 0) {
        objectStore = [];
    }
    objectStore.length = total;

    for (let i = 0; i < newObjects.length; i++) {
        objectStore[firstIndex + i] = newObjects[i];
    }

    return objectStore;
};

export default {
    dataIrrelevantProps,
    relevantProps,
    getChangedProps,
    errorCorrectLoadedSettings,
    RelationFilter,
    getUpdatedObjectStore,
};
